<div class="error-page-container">
  <div class="error-card">
    <div class="icon-container">
      <span class="material-symbols-rounded error-icon">search_off</span>
    </div>

    <h1 class="error-title">Invalid Link</h1>

    <p class="error-message">
      The link looks to be incomplete or broken for some reason.
    </p>

    <div class="helpful-info">
      <!-- <h3>Finding your link</h3> -->
      <p>
        It is possible that we may still be outstanding some information from you. Please go back to the message we sent
        you. Tapping the link straight from the text or email is the most reliable way in. If it still will not open,
        call us urgently on 01 2541300 so that we can investigate this further. Please note that our opening hours are
        9.00am-5.30pm, Monday to Friday If you can, go back to the message we sent you and tap the link straight from
        the text or email. If it still
        does not open please give us a call on <a href="tel:{{supportPhone}}"><strong>{{supportPhone}}</strong></a>.

      </p>
    </div>

  </div>
</div>